// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Encounter } from '@medplum/fhirtypes';

export const REFERENCE_CHECKLIST_EXTENSION_URL =
  'https://polarissleep.com/fhir/StructureDefinition/encounter-note-checklist';

export function readReferenceChecklist(encounter: Encounter, itemCount: number): boolean[] {
  return Array.from({ length: itemCount }, (_, index) => {
    const extension = encounter.extension?.find(
      (candidate) => candidate.url === `${REFERENCE_CHECKLIST_EXTENSION_URL}/${index}`
    );
    return extension?.valueBoolean ?? false;
  });
}

export function writeReferenceChecklist(
  extensions: Encounter['extension'],
  checklist: boolean[]
): Encounter['extension'] {
  const checklistPrefix = `${REFERENCE_CHECKLIST_EXTENSION_URL}/`;
  return [
    ...(extensions ?? []).filter((extension) => !extension.url?.startsWith(checklistPrefix)),
    ...checklist.map((checked, index) => ({
      url: `${REFERENCE_CHECKLIST_EXTENSION_URL}/${index}`,
      valueBoolean: checked,
    })),
  ];
}
